<div class="main-wrapper">
    <div class="top-head" *ngFor="let item of activeSipSubscribed; index as i">
        <div class="top-content">
            <div class="img-wrapper">
                <img [attr.data-src]="item?.sip_cause?.info_3" alt="sip cause img" />
            </div>
            <div class="sip-details">
                <div class="sip-title">
                    {{item?.campaign_cause | titlecase}}
                </div>
                <div class="upcoming-deduction-wrapper" *ngIf="!(['lapsed', 'cancelled'].includes(item.label.toLowerCase()))">
                    <div class="label-details">
                        <div class="label">
                            Upcoming deduction on: 
                        </div>
                        <div class="data">
                            {{item?.next_payment_date | date: 'dd/MM/YYYY'}}
                        </div>
                    </div>
                </div>
                <div class="upcoming-deduction-wrapper" *ngIf="item.label.toLowerCase() === 'cancelled'">
                    <div class="pledgemore-link" (click)="onResume(i)">
                        <span>{{getBtnLabel(i)}}</span>
                        <img [attr.data-src]="'/assets/images/home-v2/chevron_right.svg'" alt="chevron right" />
                    </div>
                </div>
                <div class="upcoming-deduction-wrapper" *ngIf="item.label.toLowerCase() === 'lapsed'">
                    <div class="payment-data">
                        <div class="label">Payment method: <span>{{item.payment_mode}}</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-wrap">
            <app-sip-status-label [status]="item.label" />
            <div class="pledgemore-link" *ngIf="item?.label === 'ACTIVE'" (click)="onPledgeMoreClick(i)">
                <span>Pledge More</span>
                <img [attr.data-src]="'/assets/images/home-v2/chevron_right.svg'" alt="chevron right" />
            </div>
            <div class="pledgemore-link" *ngIf="item?.label === 'PAUSED'" (click)="onResume(i)">
                <span>{{getBtnLabel(i)}}</span>
                <img [attr.data-src]="'/assets/images/home-v2/chevron_right.svg'" alt="chevron right" />
            </div>
            <div class="pledgemore-link" *ngIf="item.label === 'LAPSED'" (click)="onUpdatePayment(i)">
                <span>Restart SIP</span>
                <img [attr.data-src]="'/assets/images/home-v2/chevron_right.svg'" alt="chevron right" />
            </div>
        </div>
    </div>
</div>


<ng-template #requestSuccessfulRef>
    <div class="success-wrapper">
        <div class="img-wrapper">
            <img loading="lazy" [attr.data-src]="'/assets/images/confetti1.gif'" alt="confetti img" class="confettiimg">
        </div>
        <div class="content">
            <div class="title">Congratulations</div>
            <div class="desc">Your SIP has now been resumed</div>
        </div>
    </div>
</ng-template>